import {ClassificationTypeEnum} from '../classificationNode/ClassificationNode'
import {useGetClassificationLeafNodesForClassificationIdQuery} from '../../../../search/rtkSearchApi'
import {Autocomplete, TextField} from '@mui/material'
import React from 'react'
import {useFormikContext} from 'formik'

export const AutoCompleteClassificationNode = ({
                                                   classificationNodeIdToSearch,
                                                   formikClassificationNodeFieldName,
                                               }: {
    classificationNodeIdToSearch: ClassificationTypeEnum,
    formikClassificationNodeFieldName: string
}) => {
    const formik = useFormikContext<any>()

    const {
        data: classificationNodes = [],
        isLoading: isClassificationNodesLoading
    } = useGetClassificationLeafNodesForClassificationIdQuery(classificationNodeIdToSearch)

    const selectedValue = formik.values?.[formikClassificationNodeFieldName] || null

    return (
        <Autocomplete
            data-cy="technical-classification-form"
            data-test={selectedValue?.id || ''}
            className="form-autocomplete"
            value={selectedValue}
            options={classificationNodes}
            disabled={isClassificationNodesLoading}
            classes={{ paper: 'select-option' }}
            isOptionEqualToValue={(option, value) => option?.id === value?.id}
            getOptionLabel={option => option?.label || ''}
            onBlur={() => formik.setFieldTouched(formikClassificationNodeFieldName, true)}
            onChange={(_, value) => value && formik.setFieldValue(formikClassificationNodeFieldName, value)}
            renderOption={(props, option) =>
                <li {...props} key={option.id} data-cy={option.id}> {option.label}</li>}
            renderInput={(params) =>
                <TextField {...params}
                           placeholder={isClassificationNodesLoading ? 'Loading...' : 'Select technical classification'}
                           error={Boolean(formik.errors[formikClassificationNodeFieldName]) && Boolean(formik.touched[formikClassificationNodeFieldName])} />}
        />
    )
}
